module.exports = __webpack_public_path__ + "img/molecule.ebdae331.png";